/**
 * ATT-3384 admin half — staging tenant-override branding (re-wire of ATT-3226).
 *
 * Sources the override target's branding from the backend `tenantBrandingByHost`
 * query instead of the (deleted) static tenant map. Staging-only, gated by
 * `NEXT_PUBLIC_ALLOW_TENANT_OVERRIDE`; auth/data stay pinned to the real staging
 * tenant (ATT-3226 Option A).
 */

export { useTenantOverrideBranding } from "./useTenantOverrideBranding";
export { getOverrideBranding, hasOverrideBrandingEntry } from "./store";
export type { TenantBranding, TenantPortal } from "./fetchBranding";
